var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#5F5FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.587 2.66602H10.4137C5.56033 2.66602 2.66699 5.55935 2.66699 10.4127V21.5727C2.66699 26.4393 5.56033 29.3327 10.4137 29.3327H21.5737C26.427 29.3327 29.3203 26.4393 29.3203 21.586V10.4127C29.3337 5.55935 26.4403 2.66602 21.587 2.66602ZM23.1337 12.066L20.0137 22.1193C19.267 24.506 15.9203 24.546 15.1337 22.1727L14.2003 19.4127C13.947 18.6527 13.347 18.0393 12.587 17.7993L9.81366 16.866C7.46699 16.0793 7.49366 12.706 9.88033 11.986L19.9337 8.85268C21.907 8.25268 23.7603 10.106 23.1337 12.066Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.b6f1fe3095edf8e994ecdba4060c6840.svg";
export { ForwardRef as ReactComponent };